export default __webpack_public_path__ + "EligibleProduct1.a3d13a89.png";